export default {
    data: () => ({
    }),
    methods: {
        generateUrl: function (param, value, keepPageParam=false) {
            // keepPageParam is important to avoid the issue of applying a new filter and staying in the same page number.
            let params = this.getURLSearchParams()
            params.delete(param)
            params.set(param, value)
            if (!keepPageParam) {
                params.delete('page')
            }
            return window.location.pathname + "?" + params.toString()
        },
        getURLSearchParams: function() {
            return new URLSearchParams(document.location.search.substring(1))
        },
        removeParamsFromUrl: function (params_to_remove) {
            // Removes an instance of a parameter from a query string
            let params = this.getURLSearchParams()
            for (let param of params_to_remove) {
                params.delete(param)
            }
            return window.location.pathname + "?" + params.toString()
        },
        removeParamFromUrl: function (param, value) {
            // Removes an instance of a parameter from a query string
            let params = this.getURLSearchParams()
            params.delete(param)
            let opts = params.getAll(param).filter(item => item !== value)
            for (let opt of opts) {
                params.append(param, opt)
            }
            return window.location.pathname + "?" + params.toString()
        },
    },
    computed: {
    }
}
